import React, { FC } from 'react'
import { NeoSelectConnectedProps } from 'LibNeo'
import { ShortDataModel } from 'Models'
import { KEYS, SelectComponent } from 'Modules'

export const RoleSelect: FC<Partial<NeoSelectConnectedProps<ShortDataModel>>> = (props) => {
	return (
		<SelectComponent
			{...props}
			keySelect={KEYS.ROLE_IDS}
			label={props?.label ?? 'common.role'}
			isNeedCut
		/>
	)
}
export default RoleSelect
